import { useEffect, useMemo } from "react"
import { StyleObject } from "styletron-react"
import { colors, fonts, frames } from "../Styles"

import AttentionListItem from "./AttentionComponents/attentionListItem"
import { AttentionTypes } from "../Definitions"
import { useAppSelector } from "../Store"
import { Graph_QL } from "../Services"
import { useSystem } from "../Services/Agrisys_GqlDataCaller/SystemCalls/useSystem"
interface StatusList_Props {
    overrides?:{
        gridArea?: string
    }
  }

export default function StatusList({overrides}:StatusList_Props) {
  const farm = useAppSelector(({activeData}) => activeData.farm) ?? "";
  const domain = useMemo(() => (Graph_QL.ObjToString({domain: farm})),[farm]);
  const connection = useMemo(() => (Graph_QL.create({domain: farm})),[farm]);;

  const {call: getSystemCall, data: systemsState} = useSystem(connection); 
  
  useEffect(() => {
    getSystemCall({fetchAmount: 50})
  },[])


  const _Root = useMemo<StyleObject>(() => {
    return Object.assign(
      {} as StyleObject, //default style
      overrides&&overrides.gridArea? {gridArea:overrides.gridArea} : {}
    )
  },[overrides])
  // TODO ATTENTION DATA 
  return (
    <frames.SystemMenu $style={_Root}>
      <div style={{display: "flex", flexDirection: "column", gap: "10px", height: "100%", width: "100%"}}>
        {systemsState[domain]?.data.map((system) => (
          <AttentionListItem key={system.systemId} attentionType={AttentionTypes.good} systemContent={
            <div>
              <p style={{...fonts.header, ...fonts.fontSize4, color: colors.greyLightTertiary}}>{system.name}</p>
              <p style={{...fonts.paragraph, ...fonts.fontSize4, color: colors.greyPrimary}}>{system.systemType}</p>
            </div>
          }/>
        ))}
      </div>
    </frames.SystemMenu>
  )
}